import React, { Component } from 'react';
import { Layout, Spin, Modal } from 'antd';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { LogoName } from 'components/common/elements/Logo';
import MainMenu from './MainMenu';
import AppHeader from './AppHeader';
import { UserRoutes } from '../pages/Routes';
import { logout } from 'actions/appActions';
import { getUser } from 'actions/asyncActions';
import Breakpoint from 'components/layout/Breakpoint.js';
import * as routes from 'constants/routes.js';
import { withAsyncActions } from 'react-async-client';
import FeedbackForm from './FeedbackForm.js'
import { toggleFeedbackModal } from 'actions/appActions';

const { Content, Header } = Layout;


@withAsyncActions({
    getUser
})
@connect(state => ({
    userMeta: getUser.selectMeta(state),
    feedbackModalOpen: state.feedbackModal.open
}), { logout, toggleFeedbackModal})
export default class UserLayout extends Component {
    componentDidMount() {
        document.getElementById('root').classList.add('auth-layout');
    }

    componentWillUnmount() {
        document.getElementById('root').classList.remove('auth-layout');
    }

    componentDidUpdate() {
        const title = document.querySelector('title');
        const {pathname} = this.props.location;
        if (routes.bonus.match(pathname)) {
            title.innerHTML = 'Бонус';
        }
        if (routes.profile.match(pathname)) {
            title.innerHTML = 'Профиль';
        }
        if (routes.projects.match(pathname)) {
            title.innerHTML = 'Проекты';
        }
        if (routes.project_add.match(pathname)) {
            title.innerHTML = 'Проекты: Создание';
        }
        if (routes.project_edit.match(pathname)) {
            title.innerHTML = 'Проекты: Редактирование';
        }
        if (routes.project_application.match(pathname)) {
            title.innerHTML = 'Заявки';
        }
        if (routes.project_application_add.match(pathname)) {
            title.innerHTML = 'Заявки: Создание';
        }
        if (routes.project_application_edit.match(pathname)) {
            title.innerHTML = 'Заявки: Редактирование';
        }
        if (routes.configurator.catalog.match(pathname)) {
            title.innerHTML = 'Каталог';
        }
        if (routes.configurator.design.match(pathname)) {
            title.innerHTML = 'Коллекция';
        }
        // if (routes.configurator.frame.match(pathname)) {
        //     return 'Дизайн витрина';
        // }
        if (routes.notifications.match(pathname)) {
            title.innerHTML = 'Уведомления';
        }
    }

    render() {
        const { feedbackModalOpen } = this.props;
        const { pending, success } = this.props.userMeta;
        const { data: { user }, meta } = this.props.getUser;
        if (!meta.lastSucceedAt) {
            return null;
        }
        
        return (
            <Layout>
                <Breakpoint min="md">
                    <Header className="header">
                        <LogoName />
                        <MainMenu confirmed={user.is_confirmed} 
                            toggleFeedbackModal={this.props.toggleFeedbackModal}
                            logout={this.props.logout}
                        />
                    </Header>
                </Breakpoint>

                <Layout>
                    <Breakpoint max="md">
                        <AppHeader />
                    </Breakpoint>
                    <Spin spinning={pending} delay={400}>
                        <Content>
                            { success && <UserRoutes confirmed={user.is_confirmed} user={user}/> }
                        </Content>
                    </Spin>
                </Layout>
                {feedbackModalOpen && success && (
                    <Modal
                        title="Обратная связь"
                        visible={true}
                        onCancel={this.props.toggleFeedbackModal}
                        footer={null}
                    >
                        <FeedbackForm initialValues={{ ...user }}/>
                    </Modal>
                )}
                <ToastContainer hideProgressBar />
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/UserLayout.js